import {useTranslation} from "@i18n";
import {CDN_LINK} from "@globalConfig";
import LimitedAvaPostViewBtn from "../../../../../../../components/limitedAvailabilityComponent/LimitedAvaPostViewBtn";

import stl from "../cashPayment/CashPayment.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import {useEffect, useState} from "react";
import PaymentTabBoxPopup
    from "@/pages/post/PostViewComponents/components/leftColumn/components/paymentTabBox/PaymentTabBoxPopup";
import InstallmentCalculatorView from "@/_MiniApps/Installment-calculator/InstallmentCalculatorView";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import {BottomSheet} from "@componentsShared/BottomSheet";
import useBoolean from "@hooks/useBoolean";
import {trackEvents} from "@/common/events/events";

const LimitedAvailability = (
    {
        priceSection,
        postId,
        footer_section,
        desktop,
        g4_data,
        have_finance = false,
        isUsed,
        post
    }) => {
    const {t} = useTranslation(["web_post_view", "web_common"]);
    const [showPaymentTabBoxPopup, setShowPaymentTabBoxPopup] = useState(false);
    const {value: isCalculatorOpen, setTrue: openCalculator, setFalse: closeCalculator} = useBoolean();
    const car_condition = !(post?.details_card?.is_new.id) ? "used" : (post?.details?.is_chinese) ? "chinese" : "new";
    console.log(post, 'ii')
    console.log(post?.details?.details_card?.is_new.id, 'kk')
    //details_card.is_new.id
    console.log(car_condition, 'jj')
    const [hasInteracted, setHasInteracted] = useState(false);

    const handleFirstInteraction = ({field}) => {
        if (hasInteracted) {
            console.log('field', field)
            setHasInteracted(false);
            trackEvents("finance_calculator_interact", {
                ...g4_data,
                post_trim: g4_data?.post_ext,
                field_interaction: field
            });
        }
    };

    useEffect(() => {
        if (isCalculatorOpen) {
            setHasInteracted(true);
        } else {
            setHasInteracted(false);
        }
    }, [isCalculatorOpen]);
    const handleCalculatorClick = () => {
        openCalculator();
        trackEvents("finance_calculator_open", {
            ...g4_data,
            post_trim: g4_data?.post_ext,
        })
    }
    return (
        <>
            <div className={stl.container}>
                <div className={stl.newPriceFlx}>
                    <div>
                        <div className={stl.flexColumn}>
                            <strong className={stl.title}>
                                {t("السعر يبدأ من", {ns: "web_post_view"})}
                            </strong>
                            <strong className={stl.priceCashON}>
                                {priceSection?.vat_price?.text}
                                <span>{priceSection?.currency}</span>
                            </strong>
                        </div>
                        {priceSection?.old_price?.text_with_vat && (
                            <strong className={[stl.priceCashON, stl.oldPrice].join(" ")}>
                                {priceSection?.old_price?.text_with_vat}
                                <span>{priceSection?.currency}</span>
                            </strong>
                        )}
                    </div>
                    <div>
                        {have_finance && priceSection?.finance_price?.text && (
                            <div>
                                <div
                                    className={stl.newKastContainer}
                                    onClick={() => handleCalculatorClick()}>
                                    <strong className={stl.NKTitle}>
                                        {t("يبدأ القسط من", {
                                            ns: "web_post_view",
                                        })}
                                    </strong>
                                    <strong className={stl.NKPrice}>
                                        {priceSection?.finance_price?.text}
                                        <span>
                                      {t("ريال/شهرياً", {
                                          ns: "web_post_view",
                                      })}
                                            {priceSection?.finance_price?.text && showPaymentTabBoxPopup && (
                                                <PaymentTabBoxPopup priceSection={priceSection}
                                                                    onClose={() => setShowPaymentTabBoxPopup(false)}
                                                                    isUsed={isUsed}/>
                                            )}
                                  </span>
                                    </strong>
                                    <strong className={stl.NewOpenKastDetails}>
                                        <ProgressiveImage
                                            width={16}
                                            height={16}
                                            waitUntilInteractive
                                            src={CDN_LINK + "/assets/images/arithmetic.svg"}
                                            alt="arrow"
                                        />
                                        <span className={stl.underline}>
                                            {t("احسب التمويل", {
                                                ns: "web_post_view",
                                            })}
                                        </span>
                                    </strong>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={stl.note}>
          <span className={stl.smlNoteN}>
            <img
                width="12px"
                src={CDN_LINK + "/assets/images/GreyCheck.svg"}
                alt="tik"
            />
            <span>{priceSection?.vat_price?.header} </span>
          </span>
                </div>
                <BottomSheet
                    open={isCalculatorOpen}
                    onOpen={openCalculator}
                    onClose={closeCalculator}
                    screens={[
                        {
                            title: t('احسب قيمة التمويل', {ns: 'web_post_view'}),
                            component: <InstallmentCalculatorView
                                carCondition={car_condition}
                                cashPrice={priceSection?.vat_price.text.replace(/,/g, "")}
                                onClose={closeCalculator}
                                onInteraction={handleFirstInteraction}
                            />
                        },
                        {
                            title: t('شروط التمويل', {ns: "web_post_view"}),
                            component: <InstallmentCalculatorTerms/>
                        }
                    ]}
                />
                {desktop && (/*@fixme limited*/
                    <LimitedAvaPostViewBtn
                        footer_section={footer_section}
                        postId={postId}
                        g4_data={g4_data}
                        desktop={desktop}
                        have_finance={have_finance}
                    />
                )}
            </div>
        </>
    );
};

export default LimitedAvailability;
